import actionCreatorFactory from 'typescript-fsa';
import { ContinueShoppingDataType } from '@client/components/continue-shopping/types';
import { NAMESPACE } from './state';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const fetchingContinueShopping = actionCreator.async<null, ContinueShoppingDataType, string>(
    'FETCH_CONTINUE_SHOPPING',
);
